module.exports = __webpack_public_path__ + "img/109054.f250425d.png";